import React from "react";

import Typography from "@mui/material/Typography";
import { D1D2ConfigurationTime } from "services/CONSTANTS";

const MarqueeComponent = () => {
const marqueeMessage = `Add/Update this configuration between time window of ${D1D2ConfigurationTime}, one calendar day in advance before actual order run.`;
  return (
    <div className="marqueeDisplay marqueeDisplayD1D2">
      <Typography>{marqueeMessage}</Typography>
    </div>
  );
};

export default MarqueeComponent;
